
import { useState } from "react";

export const useBaseMutation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const startLoading = () => {
    setIsLoading(true);
    setError(null);
  };

  const setSuccess = () => {
    setIsLoading(false);
  };

  const setFailure = (errorMessage: string) => {
    setIsLoading(false);
    setError(errorMessage);
  };

  return {
    isLoading,
    error,
    startLoading,
    setSuccess,
    setFailure
  };
};
